<ng-template
  cdk-connected-overlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="internalOpen"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayOffsetX]="overlayOffsetX"
  [cdkConnectedOverlayOffsetY]="overlayOffsetY"
  [cdkConnectedOverlayHasBackdrop]="hasBackdrop"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  cdkConnectedOverlayBackdropClass="cds-tooltip-backdrop"
  (positionChange)="onPositionChange($event)"
>
  <div
    class="cds-tooltip-panel"
    [ngClass]="['arrow-' + arrowDirection, isVisible ? 'visible' : 'hidden']"
    [style.--arrow-offset.px]="arrowOffset"
    [style.width]="panelWidth === 'auto' ? 'auto' : panelWidth + 'px'"
    (mouseenter)="hovered.emit()"
    (mouseleave)="unhovered.emit()"
  >
    <ng-container *ngIf="tooltipContentTpl" [ngTemplateOutlet]="tooltipContentTpl"></ng-container>
  </div>
</ng-template>
